class Book {
    title: string;
    googleId: string;
    authors: [string];
    thumbnail: string | undefined;
}

export default Book;